import React from "react";

export default function SecondaryCTA({ children, onClick, dataTestId, type = "button", ...rest }) {
    return (
        <button type={type} className="lp-btn-secondary" onClick={onClick} data-testid={dataTestId} {...rest}>
            {children}
        </button>
    );
}
